<template>
    <div class="p-6 transition-all duration-300 bg-white rounded-lg dashboard-widget hover:shadow-lg">
        <div class="flex items-center justify-between mb-6">
            <h2 class="text-xl font-semibold text-gray-800">{{ translatedModuleName }}</h2>
            <a :href="data.link" class="text-sm font-medium transition-colors duration-200 mf-link text-wlPrimary hover:text-wlPrimary/80">
                {{ _mft('dashboard:widgets.visit') }} <i class="ml-1 fas fa-arrow-right"></i>
            </a>
        </div>

        <hr class="my-4 border-gray-100">

        <div v-for="item in data.data" :key="item.stat" class="mb-6 last:mb-0">
            <div class="flex items-end justify-between">
                <h1 class="text-3xl font-bold tracking-tight text-wlPrimary">
                    {{ formatNumber(item.value) }}
                </h1>
                <div class="text-right">
                    <h3 class="text-sm font-medium text-gray-600">{{ translateKey(item.stat) }}</h3>
                    <small class="text-xs text-gray-400">{{ translateKey(item.timeframe) }}</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, onMounted, computed } from 'vue';
    import axios from 'axios';

    const props = defineProps({
        module: String,
    });

    const data = ref({
        data: [],
        link: '#',
    });

    const fetchData = async () => {
        try {
            const response = await axios.get(route('boIndex.dashboardV2ModulesData', props.module));
            data.value = response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    onMounted(fetchData);

    const moduleTranslationMap = {
        'Landing Pages': 'modules.landingPages',
        'Web Pages': 'modules.webPages',
        'User Area Pages': 'modules.userAreaPages',
        'Coaching': 'modules.coaching',
        'Content': 'modules.content',
        'Courses': 'modules.courses',
        'Community': 'modules.community',
        'Newsletters': 'modules.newsletters',
        'Automations': 'modules.automations',
        'LeadHunter': 'modules.leadHunter',
        'Contacts': 'modules.contacts',
        'Quotes & Agreements': 'modules.quotesAndAgreements',
        'Time Tracking': 'modules.timeTracking',
        'Payments': 'modules.payments',
        'Forms': 'modules.forms',
    };

    const translatedModuleName = computed(() => {
        const translationKey = moduleTranslationMap[props.module];

        if (!translationKey) {
            return props.module;
        }

        return _mft(`dashboard:${translationKey}`);
    });

    const numberFormatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        useGrouping: true,
        maximumFractionDigits: 0,
    });

    const translateKey = (key) => {
        if (!key) {
            return '';
        }

        return _mft(`dashboard:${key}`);
    };

    const formatNumber = (value) => {
        if (value === null || value === undefined || value === '') {
            return '';
        }

        return numberFormatter.format(Number(value));
    };
</script>

<style scoped>

.dashboard-widget:hover {
    transform: translateY(-2px);
}
</style>
